import { useQuery } from '@tanstack/react-query';
import { METABASE_API_URL, metabaseApi } from '../../core/api';
import { collectionSchema } from '../../core/schemas/metabase';

export const QUERY_KEY_COLLECTION = 'collection';

export const useGetCollection = (id: number | undefined) =>
  useQuery({
    queryKey: [QUERY_KEY_COLLECTION, id],
    queryFn: async () => {
      const { data } = await metabaseApi.get(
        `${METABASE_API_URL}/collection/${id}`
      );

      const parsed = collectionSchema.safeParse(data);

      if (!parsed.success) {
        throw new Error('Failed to parse collection');
      }

      return parsed.data;
    },
    enabled: !!id,
  });
